import ReactStrapTable from 'components/reactStrapTable';
import React, { useState,useEffect } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Card, CardBody, Col, Container, Input, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import PoReconciliationTable from '../POReconciliationTable';
import useContextService from 'hooks/useContextService';
import useAxios from 'hooks/useAxios';
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import Loader from 'components/Loader';
import Checkbox from 'components/common/Fields/Checkbox';
import { type } from '@testing-library/user-event/dist/type';
import { ModuleAccess } from 'utils/moduleaccess';
import moment from 'moment';
import cancel from "assets/icon/cancel.svg";

let checkedIds = [];
let allcheckids = [];

const PoReconciliationDrawerTable = (props) => {
    
    const [data,setData] = useState([]);
    const[totalitem,setTotalItem] = useState(0);
    const [selectedOrder, setSelectedOrder] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addDisable, setAddDisable] = useState(false);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [ischecked, setIsChecked] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
  
    const [allCheckDefault, setAllCheckDefault] = useState(false);
    const [allCheck, setAllCheck] = useState("singleCheck");
    const {
        rowData,
        manvalConfigedit,
        manvalConfig,
        manvalPharmacy,
        refetch1,refetch,
        orgId,togglePODetailsDrawer
    } = props;

    useEffect(() => {
      checkedIds = [];
      setAllCheckDefault(false);
      setAllCheck("singleCheck");
  }, []);


    const  poid  = rowData;
    console.log(poid,"poid in Po Drawer")
          


    const API = useAxios();
    const {
        states: { viewPOReconciliation },
        setStates,
    } = useContextService();
    const { search } = viewPOReconciliation;

    useEffect(() => {
        fetchPOOrderDetails(search);
    }, []);
    const fetchPOOrderDetails = async (filters) => {
        debugger;
       let payload = {};
       payload.CurrentPage=1,
       payload.pageSize=filters.pageSize,
       payload.orderBy="poid",
       payload.order="desc",
       payload.filters=[],
       payload.AccumulatorIDs=[1],
       payload.AccountTypeID=0,
       payload.POStatusID = 0
    //    payload.Invoice = ""
     
        try {
          setLoading(true);
            const  {data} = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/GetPOReconciliationItems/${rowData.poid}`,payload,
                { hasDefaultURL: true,}
            )
          if (data) {
            console.log(data,"fetchPOOrderDetails Data")
            setData(data.items);
            setTotalItem(data.totalRecords);
            setLoading(false);
          }
         
        } catch (error) {
          setLoading(false);
        }
      };
      

    const handleConfig = async (rowData) => {
         await manvalConfig();
    }

    const handelAddCoveredEntity = async (rowData) => {
        await manvalPharmacy();
   }


    const handleCancelPO = async (rowData) => {
        debugger
        let payload = {}
        payload.POitemNumbers = selectedIds;

        if (selectedIds) {
            try {
              setLoading(true);
              const response = await API.post(
                `SBTenant/${orgId.tenantID}/PurchaseOrder/orderpocancel/${allCheck}`,
                payload,
                { hasDefaultURL: true }
              );
              setLoading(false);
              //fetchPOOrderDetails();
              togglePODetailsDrawer();
              refetch();

            } catch (error) {
              console.error("Error fetching data:", error);
              setLoading(false);
            }
        }
  
        await manvalConfigedit(rowData);
    }

    const renderCancelButton = (rowData) => {
        // if (hasPermission('ED'))
            return (
              <Button
                className="text-primary p-0 text-decoration-none"
                color="link"
                onClick={() => handleCancelPO(rowData)}
                title="Cancel Purchase Order"
              >
                <HoverImage
                  key="CancelIcon"
                  src={CancleIcon}
                  hoverSrc={CancleHoverIcon}
                  alt=""
                />
              </Button>
            );
    }

    const renderConfigButton = () => {

        return (
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => handleConfig()}
            title="Client Configuration"
          >
            <HoverImage src={ConfigIcon} hoverSrc={ConfigIconHover} alt="" />
          </Button>
        );
    }


    const cellRenderCancel = (rowData) => {
        return (
          <div className="d-flex align-items-center">
            {renderCancelButton(rowData)}
            {/* {renderConfigButton(rowData)} */}
            {/* {renderCommentsButton(rowData)} */}
            {/* {renderViewButton(rowData)} */}
          </div>
        );
    };
   
    const handleExport = async () => {
        const { access_token } =
            JSON.parse(localStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
        onExport(action, initialFilters);
    };


    const handleAllCheckbox = (e) => {
      debugger;
      setAllCheckDefault(e.target.checked);
      setAllCheck("checkall");
      checkedIds = [];
  
      if (e.target.checked) {
          allcheckids = [];
          if (allcheckids.length === 0) {
              for (var x in data) {
                  allcheckids.push(data[x].poItemID);
                  checkedIds.push(data[x].poItemID);
              }
              setSelectedIds([...allcheckids]);
          }
      } else {
          setSelectedIds([]);
          allcheckids = [];
          checkedIds = [];
      }
  };
  
  const hasPermission = (code) => {
          return ModuleAccess("PCO", code);
      }



const handlesinglecheckbox = (row) => {
  const { poItemID } = row;
  const index = checkedIds.indexOf(poItemID);

  if (index >= 0) {
      checkedIds.splice(index, 1);
  } else {
      checkedIds.push(poItemID);
  }

  setSelectedIds([...checkedIds]);

  // Check if all rows are selected
  if (checkedIds.length === data.length) {
      setAllCheckDefault(true);
      setAllCheck("checkall");
  } else {
      setAllCheckDefault(false);
      setAllCheck("singleCheck");
  }
};

 const dateFormateTime = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const data1 = date !== null ? date?.toLocaleString('en-US', options).replace(",", "").replace(/\//g, "/") : "-"
    return data1;
    // return moment(new Date(value)).format('MM/DD/YYYY hh:mm').toLocaleString('en-US', value).replace(",", "").replace(/\//g, "/");
  };

  const renderCheckbox = (row) => {

    const filter = selectedIds.filter((item) => item === row.poItemID);
    return (
      <Input style={{border:"1px solid #919191",width:"14px",height:"14px",}}
        onChange={() => handlesinglecheckbox(row)}
        type="checkbox"
        className="me-2 mt-0"
        value={filter.length > 0}
        checked={filter.length > 0}
      />
    );
}

    let mainCol = [

      {
        text: (
          <div>
              <label style={{color:'#212121'}}>Select All</label>
     <Input style={{position:"relative",left:"4px",top:"-4px",border:"1px solid #919191",width:"14px",height:"14px",}}
            type="checkbox"
            title={allcheckids.length == 0 ? "select all" : "unselect all"}
            onChange={(e,row) => {
              handleAllCheckbox(e,row);
            }}
            hidden={data.length == 0}
            checked={allCheckDefault}
          />
          </div>
     
        ),
        cellRenderer: (row) => renderCheckbox(row),
        width: 120,
        show: true,
        disabled: true,
        hideColFilter: true,
        action: true,
      },
      {
        dataField: "ndc",
        text: "NDC",
        sort: false,
        width: 80,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.ndc),
      },
      {
        dataField: "drugName",
        text: "Drug Name",
        sort: false,
        width: 240,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.drugName),
      },
      {
        dataField: "itemStatus",
        text: "Item Status",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.itemStatus),
      },
      {
        dataField: "qtyOrder",
        text: "Qty Ordered",
        sort: false,
        width: 80,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.qtyOrder),
      },
      {
        dataField: "qtyAck",
        text: "Qty Ack",
        sort: false,
        width: 80,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.qtyAck),
      },
      {
        dataField: "dateAck",
        text: "Date Ack",
        sort: false,
        width: 80,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => dateFormateTime(row.dateAck),
      },
      {
        dataField: "pkgPrice",
        text: "Pkg Price",
        sort: false,
        width: 80,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => currencyFormat(row.pkgPrice),
      },
      {
        dataField: "ackPkgPrice",
        text: "Ack Pkg Price",
        sort: false,
        width: 100,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => currencyFormat(row.ackPkgPrice),
      },
      {
        dataField: "totalOrdPrice",
        text: "Total Ordered Price",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => currencyFormat(row.totalOrdPrice),
      },
      {
        dataField: "totalAckPkgPrice",
        text: "Total Ack Pkg Price",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => currencyFormat(row.totalAckPkgPrice),
      },
      // {
      //     dataField: 'edit',
      //     text: 'Options',
      //     cellRenderer: (rowData) => cellRenderCancel(rowData),
      //     width: 80,
      //     show: true,
      //     disabled: true,
      //     hideColFilter: true,
      //     action: true,
      // },
    ];
//     const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
// debugger;
//         if (hasColFilter) {
//             const colFilterOn = { ...filter, filters: colChangedFilter };
//             return fetchPOOrderDetails(colFilterOn, true);
//         }
//         fetchPOOrderDetails(filter);
//     };

    const onPageSizeChange = (filter, haveColFilter) => {
      debugger;
        if (haveColFilter) {
          const filterObj = cloneDeep(search);
          filterObj.filters = [...filterObj.filters, ...filter.filters];
          filterObj.currentPage = filter.currentPage;
          filterObj.pageSize = filter.pageSize;
           filterObj.orderBy= filter.orderBy;
          filterObj.order= filter.order;
    
    
          viewPOReconciliation.search.currentPage = filter.currentPage;
          viewPOReconciliation.search.pageSize = filter.pageSize;
          viewPOReconciliation.search = { ...viewPOReconciliation.search };
          fetchPOOrderDetails(filterObj);
    
        } else {
          fetchPOOrderDetails(filter);
          viewPOReconciliation.search = { ...viewPOReconciliation.search, ...filter };
        }
        setStates('viewPOReconciliation', viewPOReconciliation);
      };
  return (
    <Card>
      <CardBody>
      <div className="py-0">
      <Row>
        <h4 className="f-15 text-primary font-weight-700">Purchase Order </h4>

        <Col md="4">
          <p className="m-0 f-14 mt-3">PO # :</p>
          <p className="m-0 f-14 font-weight-500  mt-1">{rowData.poid}</p>
        </Col>

        <Col md="4">
          <p className="m-0 f-14 mt-3">PO Date : </p>
          <p className="m-0 f-14  mt-1">
          <p className="m-0 f-14  font-weight-500 mt-1">{moment(rowData.poDate).format("MM/DD/YYYY")}</p>
            </p>
        </Col>
        <Col md="4">
          <p className="m-0 f-14 mt-3">Po Status : </p>
          <p className="m-0 f-14 font-weight-500 mt-1">{rowData.poStatusID}</p>
        </Col>
        <Col md="4">
          <p className="m-0 f-14 mt-3">Covered Entity : </p>
          <p className="m-0 f-14 font-weight-500 mt-1">
            {rowData.coveredentityName}
          </p>
        </Col>
        <Col md="4">
          <p className="m-0 f-14 mt-3">Accumulator : </p>
          <p className="m-0 f-14 font-weight-500 mt-1">
            {rowData?.accumulatorName}
          </p>
        </Col>
        <Col md="4">
          <p className="m-0 f-14 mt-3">Wholesaler : </p>
          <p className="m-0 f-14 font-weight-500 mt-1">
            {rowData.wholesalerName}
          </p>
        </Col>

        <Col md="4">
          <p className="m-0 f-14 mt-3">Ordered Price : </p>
          <span className="m-0 f-14 font-weight-500 mt-1"></span>

          <p className="m-0 f-14 font-weight-500 mt-1">
            {currencyFormat(rowData.totalOrderedPrice)}
          </p>
        </Col>
        {/* <Col md="4">
          <p className="m-0 f-14 mt-3">Total Invoiced Price : </p>
          <span className="m-0 f-14 font-weight-500 mt-1"></span>
          <p className="m-0 f-14 font-weight-500 mt-1">
            {rowData.invoicedPrice}
          </p>
        </Col> */}
        <Col md="4">
          <p className="m-0 f-14 mt-3">
            Account Type :{" "}<br/>
            <span className="m-0 f-14 font-weight-500 mt-1">
              {" "}
              {rowData.accountType}
            </span>
          </p>
        </Col>
      </Row>
      <hr></hr>
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data.length > 0 ? "fixed-height" : "default"}
      >
        {loading && <Loader opacity={0.02} color="black" />}
        <ReactStrapTable
          id="poitems-table"
          height={550}
          fixedColumn
          width={1200}
          hidefilter
          data={data}
          columns={mainCol}
          //filters={search}
          totalRecords={totalitem}
          // pageSize={search.pageSize}
          // currentPage={search.CurrentPage}
          // onPageSizeChange={onPageSizeChange}
          // filtershow={true}
          // add={"Upload"}
          // addbutton={true}
          // // handelAddCoveredEntity={handelAddCoveredEntity}
          // onExport={handleExport}
          // filters={2}
          // totalRecords={1}
          //  pageSize={20}
          // currentPage={1}
          // handleSort={onHandleSort}
          // onPageChange={onHandlePageChange}
          // onPageSizeChange={onPageSizeChange}
          // onFilterCancel={handleFilterCancel}
          // onSearchColumnFilters={handleSearchColumnFilters}
          // hasExportPermission={hasExportPermission}
        />
           <Row className="d-flex mt-3" style={{ justifyContent: "flex-end" }}>
                                    <Col md="auto" className="">
            <Button id="deleteButton" className='reset' color='primary' onClick={handleCancelPO} disabled={checkedIds.length == 0} hidden={!hasPermission('CO')}>
            {/* <Button id="deleteButton" onClick={handleCancelPO} > */}

              <span className="right_5"><img src={cancel} alt="" /></span> Cancel Selected Orders
            </Button>
          </Col>
        </Row>
      </div>
    </div>
      </CardBody>
    </Card>
  
  );
}

export default PoReconciliationDrawerTable
